import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import { showToast } from '../../showTost';

const Profile = () => {

  const { BaseUrl, islogin } = useContext(MyContext);

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [passtype, setPassType] = useState("password");
  const [error, setError] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);

  useEffect(() => {
    const LocalData = secureLocalStorage.getItem("Logindata");
    if (LocalData) {
      const { name, password } = JSON.parse(LocalData);
      setName(name);
      setPassword(password);
    }
  }, [islogin]);

  const handleContinue = () => {

    if (!name || !password) {
      setError(true);
      return;
    }

    setBtnLoading(true);
    const uid = secureLocalStorage.getItem("Userid");

    axios.post(`${BaseUrl}/eapi/e_profile_edit.php`, { uid, name, password })
      .then((res) => {
        // console.log("e_profile_edit.php", res.data);
        const { ResponseCode, ResponseMsg } = res.data;
        const Toastid = ResponseCode === "200" ? "success" : "error";
        showToast({ title: ResponseMsg, id: Toastid });
        setBtnLoading(false);
      })
      .catch((error) => {
        console.error("e_profile_edit.php", error);
      })
  }

  return (
    <div className="text-black login_page mt-[30px]">

      <div className="relative mb-[10px]">
        <input value={name} onChange={(e) => setName(e.target.value)}
          type="text"
          id="Name"
          placeholder=""
          className="peer w-full border font-bold h-[65px] border-gray-400 outline-none px-[20px] pt-[15px] rounded-[5px]"
        />
        <label style={{ color: (error && !name) && "red" }}
          htmlFor="Name"
          className={`absolute left-[20px] text-gray-500 font-medium transition-all duration-200
                  ${!name
              ? 'peer-placeholder-shown:top-5 peer-placeholder-shown:text-base'
              : 'top-2 text-xs'} peer-focus:top-2 peer-focus:text-xs`}
        >
          {(error && !name) ? "Enter your name" : "Name"}
        </label>
      </div>

      <div className="relative mt-[20px]">
        <div className="flex items-center justify-between border border-gray-400 px-[20px] rounded-[5px]">
          <input value={password} onChange={(e) => setPassword(e.target.value)}
            type={passtype}
            id="input"
            placeholder=""
            className="peer w-full font-bold h-[65px] pt-[15px] outline-none"
          />
          <button onClick={() => setPassType(passtype === "password" ? "text" : "password")}>
            {passtype === "password"
              ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.229 13.8679C19.913 16.0639 16.96 19.75 12 19.75C11.037 19.75 10.0861 19.604 9.17408 19.315C8.77908 19.19 8.56105 18.769 8.68605 18.374C8.81005 17.978 9.23496 17.762 9.62696 17.885C10.392 18.127 11.19 18.25 12 18.25C16.222 18.25 18.7901 15.02 19.9441 13.094C20.3521 12.418 20.3521 11.581 19.9461 10.907C19.6001 10.324 19.177 9.72798 18.72 9.17898C18.455 8.85998 18.4991 8.38707 18.8181 8.12307C19.1381 7.85807 19.61 7.90199 19.875 8.21999C20.381 8.82899 20.8509 9.49199 21.2329 10.137C21.9259 11.284 21.926 12.7159 21.229 13.8679ZM10.063 14.9981L3.53004 21.531C3.38404 21.677 3.19201 21.751 3.00001 21.751C2.80801 21.751 2.61598 21.678 2.46998 21.531C2.17698 21.238 2.17698 20.763 2.46998 20.47L5.64503 17.2949C4.31703 16.1499 3.35205 14.837 2.76905 13.866C2.07505 12.716 2.07501 11.2841 2.77101 10.1331C4.08701 7.93708 7.04001 4.251 12 4.251C13.835 4.251 15.565 4.76994 17.155 5.78494L20.469 2.47097C20.762 2.17797 21.237 2.17797 21.53 2.47097C21.823 2.76397 21.823 3.23901 21.53 3.53201L10.065 14.9971C10.065 14.9971 10.065 14.9981 10.064 14.9981C10.063 14.9981 10.063 14.9971 10.063 14.9981ZM9.6089 13.3311L13.3311 9.60891C12.9291 9.38191 12.478 9.251 12 9.251C10.484 9.251 9.25099 10.484 9.25099 12.001C9.25099 12.478 9.3829 12.9291 9.6089 13.3311ZM6.70704 16.232L8.51905 14.4199C8.02405 13.7169 7.75099 12.882 7.75099 11.999C7.75099 9.65605 9.65701 7.74905 12 7.74905C12.884 7.74905 13.7179 8.02211 14.4209 8.51711L16.052 6.88601C14.787 6.14501 13.432 5.74807 12 5.74807C7.77801 5.74807 5.20992 8.97808 4.05592 10.9041C3.64792 11.5801 3.64797 12.4171 4.05397 13.0911C4.59097 13.9881 5.48304 15.201 6.70704 16.232ZM14.708 12.4351C14.528 13.5951 13.594 14.53 12.436 14.709C12.027 14.772 11.7461 15.155 11.8091 15.564C11.8671 15.935 12.1861 16.2 12.5491 16.2C12.5871 16.2 12.6261 16.1969 12.6641 16.1909C14.4911 15.9089 15.908 14.4921 16.19 12.6641C16.253 12.2541 15.973 11.8721 15.563 11.8081C15.163 11.7471 14.771 12.0251 14.708 12.4351Z" fill="black" />
              </svg>
              : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.2352 10.1379C19.9222 7.93894 16.9751 4.25 12.0001 4.25C7.02511 4.25 4.07801 7.93894 2.76501 10.1379C2.07801 11.2859 2.07801 12.7131 2.76501 13.8621C4.07801 16.0611 7.02511 19.75 12.0001 19.75C16.9751 19.75 19.9222 16.0611 21.2352 13.8621C21.9222 12.7131 21.9222 11.2869 21.2352 10.1379ZM19.9481 13.092C18.7981 15.018 16.2351 18.25 12.0001 18.25C7.76511 18.25 5.20212 15.019 4.05212 13.092C3.65012 12.418 3.65012 11.581 4.05212 10.907C5.20212 8.98098 7.76511 5.74902 12.0001 5.74902C16.2351 5.74902 18.7981 8.97998 19.9481 10.907C20.3511 11.582 20.3511 12.418 19.9481 13.092ZM12.0001 7.75C9.65611 7.75 7.75011 9.657 7.75011 12C7.75011 14.343 9.65611 16.25 12.0001 16.25C14.3441 16.25 16.2501 14.343 16.2501 12C16.2501 9.657 14.3441 7.75 12.0001 7.75ZM12.0001 14.75C10.4831 14.75 9.25011 13.517 9.25011 12C9.25011 10.483 10.4831 9.25 12.0001 9.25C13.5171 9.25 14.7501 10.483 14.7501 12C14.7501 13.517 13.5171 14.75 12.0001 14.75Z" fill="black" />
              </svg>}
          </button>
          <label style={{ color: (error && !password) && "red" }}
            htmlFor="input"
            className={`absolute left-[20px] text-gray-500 font-medium transition-all duration-200
                  ${!password
                ? 'peer-placeholder-shown:top-5 peer-placeholder-shown:text-base'
                : 'top-2 text-xs'} peer-focus:top-2 peer-focus:text-xs`}
          >
            {(error && !password) ? "Enter your password" : "Password"}
          </label>
        </div>
      </div>

      <button onClick={handleContinue} className="w-full bg-[#ff5200] rounded-[5px] text-white mt-[20px] py-[15px] font-bold">
        {btnloading
          ? <div className="btn_loader mx-auto"></div>
          : <span>UPDATE</span>}
      </button>

    </div>
  )
}

export default Profile